import { useState } from "react";
import { authClient } from "@/auth";
import { Button } from "@/components/catalyst/Button";
import { GitHub } from "@/components/icons/GitHub";
import { Google } from "@/components/icons/Google";

export function Socials() {
	const [pending, setPending] = useState(false);

	const signIn = (provider: "github" | "google") => () => {
		setPending(true);
		authClient.signIn.social({
			provider,
			callbackURL: `${window.location.origin}/dashboard`,
			fetchOptions: {
				onError: () => setPending(false),
			},
		});
	};

	return (
		<>
			<div className="divider my-4">OR</div>

			<div className="flex flex-col gap-4">
				<Button
					type="button"
					color="dark/white"
					onClick={signIn("github")}
					disabled={pending}
					className="flex-1 flex items-center gap-2"
				>
					<GitHub className="size-4" />
					<div>Sign in with GitHub</div>
				</Button>
				<Button
					type="button"
					color="dark/white"
					onClick={signIn("google")}
					disabled={pending}
					className="flex-1 flex items-center gap-2"
				>
					<Google className="size-4" />
					<div>Sign in with Google</div>
				</Button>
			</div>
		</>
	);
}
